import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/icon_default_user_new.svg'
import _imports_1 from '@/assets/icons/icon_default_doctor_new.svg'


const _hoisted_1 = { class: "choose-user-identity" }
const _hoisted_2 = { class: "user-identity-list" }

import { NButton } from "naive-ui";
import { ref, computed, watch } from "vue";
import { MessageAlert } from "@/composables/useMessageAlert";
import { UserRole } from "@/constant";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChoseUserIdentify',
  props: {
    curRoleType: {
        type: String,
        default: () => {
            return "";
        },
    },
},
  emits: ["onNext"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const curChooseCareerSelected = ref<number>(0);
const isDisabledChooseCareerSelected = computed(() => {
    return curChooseCareerSelected.value ? false : true;
});

watch(
    () => props.curRoleType,
    (newV) => {
        curChooseCareerSelected.value = newV === UserRole.User.toUpperCase() ? 1 : newV === UserRole.Doctor.toUpperCase() ? 2 : 0;
    },
    { immediate: true }
);

const _hdanleChooseCareerSelected = (type: number) => {
    curChooseCareerSelected.value = type;
    setTimeout(()=>{
        _handleChooseCareerNext();
    }, 1000)
};

// 注册-选择完职业之后点击next按钮
const _handleChooseCareerNext = () => {
    if (isDisabledChooseCareerSelected.value) {
        MessageAlert("Please choose a User identity");
        return;
    }
    emits("onNext", curChooseCareerSelected.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "user-identity-title" }, "Choose your identity", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["user-identity-item", { selected: curChooseCareerSelected.value === 1 }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_hdanleChooseCareerSelected(1)), ["stop"]))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "user-identity-item-img-cont" }, [
          _createElementVNode("img", { src: _imports_0 })
        ], -1),
        _createElementVNode("div", { class: "user-identity-item-name" }, "Sign up as Member", -1)
      ]), 2),
      _createElementVNode("div", {
        class: _normalizeClass(["user-identity-item", { selected: curChooseCareerSelected.value === 2 }]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_hdanleChooseCareerSelected(2)), ["stop"]))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "user-identity-item-img-cont" }, [
          _createElementVNode("img", { src: _imports_1 })
        ], -1),
        _createElementVNode("div", { class: "user-identity-item-name" }, "Sign up as Doctor", -1)
      ]), 2)
    ])
  ]))
}
}

})